import { eq } from "drizzle-orm";
import { attachment, type PowerSyncDrizzleDB } from "@cashsync/powersync";
import { nowISO } from "../utils/date-helpers";
import { generateId } from "@fleet/utils";

/**
 * Creates an attachment (receipt) linked to a transaction. Local user_id is
 * needed for the row to pass the `finance` stream filter; the server
 * also enforces it to match the JWT on write-back.
 */
export async function addAttachmentMutation({
  db,
  txId,
  userId,
  filename,
  url,
  contentType,
  size,
}: {
  db: PowerSyncDrizzleDB;
  txId: string;
  userId: string;
  filename: string;
  url: string;
  contentType: string;
  size: number;
}) {
  const id = generateId();
  const now = nowISO();
  await db.insert(attachment).values({
    id,
    tx_id: txId,
    user_id: userId,
    filename,
    url,
    content_type: contentType,
    size,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export async function deleteAttachmentMutation(db: PowerSyncDrizzleDB, id: string) {
  await db.delete(attachment).where(eq(attachment.id, id));
}
